import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LoanFastrackPaymentsStore } from '../stores/loanFastrackPaymentsStore';

export const useLoanFastrackPaymentsStore = () => useContext<{
  loanFastrackPaymentsStore: LoanFastrackPaymentsStore
}>(StoreContext);
